module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view'), _vm._v(" "), _c('div', {
    staticClass: "width-wrapper relative"
  }, [_c('div', {
    staticClass: "rack-list",
    attrs: {
      "title": ""
    }
  }, _vm._l((_vm.racks), function(rack) {
    return _c('div', {
      staticClass: "rack-list-item",
      attrs: {
        "title": ""
      }
    }, [(rack.has_changes && _vm.$store.state.user.role === 'HM') ? _c('div', {
      staticClass: "has-changes"
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "rack-list-item__name",
      attrs: {
        "id": rack.id
      }
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.$router.push(("/pharmacies/" + _vm.pharmacy + "/racks/" + (rack.id) + "/"))
        }
      }
    }, [_vm._v(_vm._s(rack.title))])]), _vm._v(" "), _c('div', {
      staticClass: "rack-list-item__group"
    }), _vm._v(" "), _vm._l((rack.shelfs), function(shelf, index) {
      return _c('div', {
        staticClass: "rack-list-shelf",
        class: shelf.template_shelf !== null ? 'rack-list-shelf--template' : '',
        attrs: {
          "title": ""
        }
      }, [(shelf.has_changes) ? _c('div', {
        staticClass: "has-changes"
      }) : _vm._e(), _vm._v(" "), (shelf.template_shelf === null) ? _c('div', [_c('div', {
        on: {
          "click": function($event) {
            return _vm.$router.push(("/pharmacies/" + _vm.pharmacy + "/racks/" + (rack.id) + "/" + (shelf.id) + "/"))
          }
        }
      }, [(_vm.$store.state.user.role === 'HM') ? _c('img', {
        staticClass: "rack-list-shelf__image new-ver",
        attrs: {
          "src": shelf.photo,
          "alt": ""
        }
      }) : _c('img', {
        staticClass: "rack-list-shelf__image last-ver",
        attrs: {
          "src": shelf.lastVerPhoto,
          "alt": ""
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "rack-list-shelf__number"
      }, [_vm._v("# " + _vm._s(rack.shelfs.length - (index)))])]), _vm._v(" "), (_vm.$store.state.user.role === 'HM') ? _c('div', {
        staticClass: "rack-list-operations-module"
      }, [_c('a', {
        staticClass: "top-nav__link",
        on: {
          "click": function($event) {
            return _vm.$router.push(("/pharmacies/" + _vm.pharmacy + "/racks/" + (rack.id) + "/" + (shelf.id) + "/"))
          }
        }
      }, [_vm._v("Перейти")]), _vm._v(" "), _c('a', {
        staticClass: "top-nav__link",
        on: {
          "click": function($event) {
            return _vm.$router.push(("/pharmacies/" + _vm.pharmacy + "/racks/" + (rack.id) + "/" + (shelf.id) + "/copy/"))
          }
        }
      }, [_vm._v("Скопировать")]), _vm._v(" "), _c('a', {
        staticClass: "top-nav__link",
        on: {
          "click": function($event) {
            return _vm.$router.push(("/pharmacies/" + _vm.pharmacy + "/racks/" + (rack.id) + "/" + (shelf.id) + "/template/"))
          }
        }
      }, [_vm._v("Заменить эталонной")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (shelf.template_shelf !== null) ? _c('div', [_c('div', {
        on: {
          "click": function($event) {
            return _vm.$router.push(_vm.$store.state.user.role === 'HM' ? ("/pharmacies/" + (shelf.template_shelf.pharmacy) + "/racks/" + (shelf.template_shelf.rack) + "/" + (shelf.template_shelf.id) + "/") : ("/pharmacies/" + _vm.pharmacy + "/racks/" + (rack.id) + "/" + (shelf.id) + "/"))
          }
        }
      }, [(_vm.$store.state.user.role === 'HM') ? _c('img', {
        staticClass: "rack-list-shelf__image new-ver",
        attrs: {
          "src": shelf.template_shelf.photo,
          "alt": ""
        }
      }) : _c('img', {
        staticClass: "rack-list-shelf__image last-ver",
        attrs: {
          "src": shelf.lastVerPhoto,
          "alt": ""
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "rack-list-shelf__number"
      }, [_vm._v("# " + _vm._s(rack.shelfs.length - (index)))])]), _vm._v(" "), (_vm.$store.state.user.role === 'HM') ? _c('div', {
        staticClass: "rack-list-operations-module"
      }, [_c('a', {
        staticClass: "top-nav__link",
        on: {
          "click": function($event) {
            return _vm.removeLink(shelf.id)
          }
        }
      }, [_vm._v("Отменить привязку")])]) : _vm._e()]) : _vm._e()])
    })], 2)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "rack-list-navigation",
    class: _vm.navClass
  }, _vm._l((_vm.racks), function(rack) {
    return _c('div', {
      staticClass: "rack-list-navigation-item",
      attrs: {
        "title": ""
      }
    }, [_c('a', {
      staticClass: "rack-list-navigation-item__name",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.navClicked(rack.id)
        }
      }
    }, [_vm._v(_vm._s(rack.title))])])
  }), 0)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-89671b9a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pharmacy/rack/RackList.vue
// module id = 250
// module chunks = 1